import React from 'react';
import { MediaItemView } from '../../components';
import { TouchableOpacity } from '../../common';
import { FileUploadOutput } from '@zonofi/zono-money-store';
import { SVGS } from '../../assets';
import './upload-media-view.scss';

interface UploadMediaViewProps {
  uploadedMedia: FileUploadOutput[];
  selectedMedia?: FileUploadOutput | undefined;
  imageIdToParse?: number | undefined;
  onUploadPress: () => void;
  onMediaPress: (media: FileUploadOutput) => void;
  onThreeDotPress: (media: FileUploadOutput) => void;
  uploadText?: string;
}

export const UploadMediaView: React.FC<UploadMediaViewProps> = ({
  uploadedMedia,
  selectedMedia,
  imageIdToParse,
  onUploadPress,
  onMediaPress,
  onThreeDotPress,
  uploadText = 'Upload',
}) => {
  return (
    <div className="upload-media">
      {/* Upload button */}
      <TouchableOpacity className="upload-media-pick" onPress={onUploadPress}>
        <img src={SVGS.UploadFile} alt="Upload icon" />
        <span className="upload-media-pick--text font-regular">
          {uploadText}
        </span>
      </TouchableOpacity>

      {/* Uploaded media list */}
      {uploadedMedia?.map((media) => (
        <MediaItemView
          key={media?.lastModified}
          media={media}
          onThreeDotPress={() => onThreeDotPress(media)}
          className={`upload-media-pick--bg ${
            selectedMedia?.lastModified === media?.lastModified
              ? 'upload-media-pick--selected'
              : ''
          }`}
          leftIcon={
            imageIdToParse === media?.lastModified
              ? SVGS.CheckGreen
              : SVGS.ImageFrame
          }
          onMediaPress={() => onMediaPress(media)}
        />
      ))}
    </div>
  );
};
